const _detect = (): boolean => {
  try {
    const search = window.location.search ?? ''
    const hash = window.location.hash ?? ''
    const combined = search + '&' + hash
    return /[?&#]googleVerification=true(&|$|#)/.test(combined + '&')
  } catch {
    return false
  }
}

const _active = _detect()

const isGoogleVerificationMode = (): boolean => _active

export default isGoogleVerificationMode
